'use client'

import Link from 'next/link'
import { cx } from 'class-variance-authority'
import { Button } from '@skop-app/lib-front'

import { Dialog } from '@/components/atoms/Dialog'

export type ConfirmationCardProps = {
  title: string
  description?: string
  className?: string
  variant?: 'info' | 'default' | 'destructive' | 'success' | 'neutral'
  actionButtons?: {
    label: string
    className?: string
    link?: string
    variant?:
      | 'primary'
      | 'ghost'
      | 'action'
      | 'icon'
      | 'error'
      | 'secondary'
      | 'outline'
      | 'underline'
    onClick?: () => void
  }[]
  hideModal?: () => void
}

export const ConfirmationCard = ({
  title,
  description,
  className,
  variant = 'info',
  actionButtons,
  hideModal,
}: ConfirmationCardProps) => {
  const descriptionClassName = cx(
    'text-slate-500',
    variant === 'destructive' && 'text-red-700',
    variant === 'success' && 'text-emerald-700',
    className,
  )

  return (
    <>
      {title ? <Dialog.Title>{title}</Dialog.Title> : null}
      {description ? (
        <Dialog.Description asChild>
          <div className={descriptionClassName}>{description}</div>
        </Dialog.Description>
      ) : null}
      {actionButtons?.length ? (
        <Dialog.Footer className="flex justify-end gap-4">
          {actionButtons?.map((button) => (
            <Button
              key={button.label}
              asChild={!!button.link}
              variant={button.variant}
              onClick={() => {
                button.onClick?.()
                hideModal?.()
              }}
              className={button.className}
            >
              {button.link ? (
                <Link href={button.link}>{button.label}</Link>
              ) : (
                button.label
              )}
            </Button>
          ))}
        </Dialog.Footer>
      ) : null}
    </>
  )
}
